import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';


import { fluidType } from 'Shared/common/FluidType';
import { Oswald } from 'Shared/frontend/fonts/Oswald';
import { Roboto } from 'Shared/frontend/fonts/Roboto';
import { Veneer } from 'Shared/frontend/fonts/Veneer';
import { INav } from 'Common/config/INav';
import { lazy } from 'solid-js';

import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 
import { title } from '../Title';



export class Showcase4Settings extends BaseSettings
{
	palette()
	{
		return{
			background: '#000000',
			text: '#FFFFFF',
			inverseText: '#000000',
			feature: '#f26822', //brewlab orange
			feature2: '#135A33', //brewlab green
			feature3: '#FEF1E2', //brewlab cream


			/* Eg the mobile nav colour */
			dimBackground: '#222',

			food: '', 
			drinks: '',
			
		};
	}

	fontIncludes()
	{
		return [
			Oswald,
			Roboto,
			Veneer
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Roboto", serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,18),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Veneer Regular", sans-serif',
			letterSpacing: 2,
			color: this.palette().feature,	
			lineHeight: 1.2,
			margin: '.3em 0',
		})
	}

	fontsHeading2()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			color: this.palette().text,
			fontWeight: '300',
			lineHeight: 1.5,
		})
	}

	fontsHeading3()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			letterSpacing: 3,
			lineHeight: 1.2,
			fontWeight: '400',
			color: this.palette().feature2,	
		})
	}

	fonts()
	{
		return {
			text: '"Oswald", sans-serif',
			heading: '"Veneer Regular", sans-serif',
			subNav: '"Oswald", sans-serif',
			buttons: '"Oswald", sans-serif',
			desktopNav: '"Oswald", sans-serif',
			mobileNav: '"Oswald", sans-serif',
		};
	}

	
	// on -development (not .test) these properties were being ignored when added to the 
	fixHeadingLoadIssue()
	{
		return({
			lineHeight: 1.2,
			margin: '.3em 0',
		})

	}

	//For consistency on all navs inc sticky subs, hire, home, event lineups
	subNavButtons()
	{
		return({
			backgroundColor: this.palette().background,
			borderStyle: 'solid',
			borderWidth: 1,
			borderColor: this.palette().feature,
			color: this.palette().feature,
			//borderRadius: '0.4em',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,15,20),
			textTransform: "uppercase",
		})
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				lineHeight: 1.2,
				margin: '.3em 0',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,80),
		
			},
			plain: {
				...this.fontsText(),
			},
			title: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,80),
				textTransform: 'uppercase',
				lineHeight: 1.2,
				margin: '.3em 0',
			},
			subtitle: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,50),
				lineHeight: 1.2,
				margin: '.3em 0',
		
			},
			teaser: {
				...this.fontsHeading2(),
			
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),
			},
			tagline: {
				...this.fontsHeading2(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,30),	
			},
		
		});
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},


			button: {
				...this.subNavButtons(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,20),
			},

			widgets: {

				scrollStyle:{
					scrollbarColor: '#000000 #3b3b3b !important',
				},
				overlay: {

					'.text-teaser':{
						fontWeight: '700',
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,64),
						textShadow: '0 0 5px black',
		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,64,160),
						textShadow: '0 0 5px black',
					
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,100),
						textShadow: '0 0 5px black',
						
					},
					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,36),
						fontWeight: '400',
						textShadow: '0 0 5px black',
					},

					'.text-plain': {
						textShadow: '0 0 5px black',
					},

					button: {
					...this.subNavButtons(),
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,30),
					},
				},
				subNav: {
					button: {
						...this.subNavButtons(),
					}
				},
			},

		});
	}

	//navigation
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',
				settings: {
					outer: {
						background: this.palette().background,
					},
						
					button: {
						...this.fontsHeading(),
						color: palette.text,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,40),
				
						':hover': {
							color: palette.feature
						}
					},
					active: {
						color: palette.feature,
					}
				}
			},

			mobile:{		
				overlay:{background: palette.background},
		
				button:{
					color: palette.text,
					background: palette.background,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.text} !important`
					},

					':hover': {
					//TODO cf remove from BaseTheme?						
						backgroundColor: `hsl(from ${this.palette().background} h calc(s + 15) calc(l + 15))`,
						color: palette.feature,
						svg:{
							fill: `${palette.feature} !important`
						},
					}
				},
				active: {
					color: palette.feature,
					backgroundColor: `hsl(from ${this.palette().background} h calc(s + 15) calc(l + 15))`,
					
					svg:{
						fill: `${palette.feature} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.background,

					},
					button: {
					
						':hover': {
							color: this.palette().feature,
							backgroundColor: `hsl(from ${palette.background} h calc(s + 15) calc(l + 15))`
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		base.specials = {
			general: 'General',
			beers: 'Beers'
		};

		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					button:{
						...this.subNavButtons(),
					}
				},

				heading: {
					...this.fontsHeading2(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						...this.subNavButtons(),
					},
				},

				section: {
					marginBottom: '3em',

				},

				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),	
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
	
	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
			//	{label:'Book', link:'frontend/Book'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
			//		{label:'Book',		link:'frontend/Book', 	icon:Contact},
				
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
				]
			}
		};
	}

	routes()
	{
		return class extends super.routes() {
			frontendContent()
			{
				return [
					...super.frontendContent(),

					//FIXME replace these with redirects (need to reimplement these as a possibility)
					{
						path: '/book',
						component: lazy(() => import('Shared/frontend/CustomPage')),
					},
				
				];
			}
		};
	}

}

